module.exports = __webpack_public_path__ + "img/14.0d6376fb.jpg";